import { CheckCircle2, X } from 'lucide-react'
import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import { uid } from '../utils/id'

type ToastItem = { id: string; message: string }
const ToastContext = createContext<(message: string) => void>(() => undefined)

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([])
  const toast = useCallback((message: string) => {
    const id = uid(); setItems(current => [...current, { id, message }])
    window.setTimeout(() => setItems(current => current.filter(item => item.id !== id)), 3200)
  }, [])
  return <ToastContext.Provider value={toast}>
    {children}
    <div className="toast-stack" aria-live="polite">
      {items.map(item => <div className="toast" key={item.id}><CheckCircle2 size={18}/><span>{item.message}</span><button aria-label="Закрыть" onClick={() => setItems(current => current.filter(i => i.id !== item.id))}><X size={15}/></button></div>)}
    </div>
  </ToastContext.Provider>
}

export const useToast = () => useContext(ToastContext)
